import Grid from '@mui/material/Grid';
import CVDCardGenetics from '../../../../../../components/Cards/CVDCardGenetics';
import CardElements from "../../../../../../components/TextComps/CardElements";
import Fam from "./FamChol/Fam";
import Fam_Variants from "./FamChol/Fam_Variants";
import Fam_Signal from "./FamChol/Fam_Signal";
import Lip from "./LipChol/Lip";
import Lip_Variants from "./LipChol/Lip_Variants";
import Lip_Signal from "./LipChol/Lip_Signal";


export default function Cholesterol() {

return (
<>
<CVDCardGenetics 

cardheadline = 'LIPIDS'
content = {<>

                <Grid container> 

                        <CardElements element1={<Fam />} element2={<Fam_Variants />} element3={<Fam_Signal />} />
                        <CardElements element1={<Lip />} element2={<Lip_Variants />} element3={<Lip_Signal />} />
                        
                </Grid>
    </>}   
    
/>    
</>
)};
